// Task list order mode, mirroring Android's TaskListOrderMode (DataStore key
// selected_task_list_order_mode). localStorage only on web. Default NAME_ASC.
export const ORDER_KEY = "selected_task_list_order_mode";

export const ORDER_MODES = {
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  DUE_DATE_ASC: "DUE_DATE_ASC",
  DUE_DATE_DESC: "DUE_DATE_DESC",
  CREATED_AT_ASC: "CREATED_AT_ASC",
  CREATED_AT_DESC: "CREATED_AT_DESC",
};

// Labels match Android's task_order_* strings.
export const ORDER_OPTIONS = [
  { value: ORDER_MODES.NAME_ASC, label: "Name Ascending" },
  { value: ORDER_MODES.NAME_DESC, label: "Name Descending" },
  { value: ORDER_MODES.DUE_DATE_ASC, label: "Due Date Ascending" },
  { value: ORDER_MODES.DUE_DATE_DESC, label: "Due Date Descending" },
  { value: ORDER_MODES.CREATED_AT_ASC, label: "Added Date Ascending" },
  { value: ORDER_MODES.CREATED_AT_DESC, label: "Added Date Descending" },
];

const ASCENDING = new Set([
  ORDER_MODES.NAME_ASC,
  ORDER_MODES.DUE_DATE_ASC,
  ORDER_MODES.CREATED_AT_ASC,
]);

export const isAscending = (mode) => ASCENDING.has(mode);

export const getTaskOrderMode = () => {
  try {
    const v = localStorage.getItem(ORDER_KEY);
    return ORDER_MODES[v] ? v : ORDER_MODES.NAME_ASC;
  } catch (e) {
    return ORDER_MODES.NAME_ASC;
  }
};

export const setTaskOrderMode = (mode) => {
  try {
    localStorage.setItem(ORDER_KEY, mode);
  } catch (e) {
    /* ignore */
  }
};

// Return a new sorted array, matching Android's orderTasks (CREATED_AT uses the
// numeric id as the insert-order proxy; "Added Date").
export const orderTasks = (tasks, mode) => {
  const arr = [...tasks];
  switch (mode) {
    case ORDER_MODES.NAME_ASC:
      return arr.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
    case ORDER_MODES.NAME_DESC:
      return arr.sort((a, b) => (b.title || "").localeCompare(a.title || ""));
    case ORDER_MODES.DUE_DATE_ASC:
      return arr.sort((a, b) => (a.dueDate || 0) - (b.dueDate || 0));
    case ORDER_MODES.DUE_DATE_DESC:
      return arr.sort((a, b) => (b.dueDate || 0) - (a.dueDate || 0));
    case ORDER_MODES.CREATED_AT_ASC:
      return arr.sort((a, b) => Number(a.id) - Number(b.id));
    case ORDER_MODES.CREATED_AT_DESC:
      return arr.sort((a, b) => Number(b.id) - Number(a.id));
    default:
      return arr;
  }
};
